module.exports = __webpack_public_path__ + "static/media/logoTitle.9f4a14ea.png";